<script>
/**
 * 報告不要業者選択画面
 */
import {mapActions} from "vuex";
import PrefectureList from '../../../../mixins/PrefectureList'
import Confirm from "../../../../components/Confirm.vue";
/**
 * 報告不要業者データ補完
 * 報告不要業者選択モーダル
 */
export default {
  name: "NoneReportingTraderSearchModal",
  components: {Confirm},
  mixins: [PrefectureList],
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    /**
     * 対象マニフェスト運搬詳細
     */
    targetItem: {
      type: Object,
      default: () => null,
    },
    targetSelectableIds: {
      type: Array,
      default: () => [],
    },
    searchedAt: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      panel: null,
      page: 1,
      totalVisible: 7,
      selectedItem: null,
      selectedRow: null,
      tableHeaders: [
        { text: "事業者コード", value: "trader_code", sortable: false, width: "10%" },
        { text: "報告不要業者", value: "trader_name", sortable: false, width: "20%" },
        { text: "業者住所", value: "trader_address", sortable: false, width: "25%" },
        { text: "報告不要業者事業場", value: "location_name", sortable: false, width: "20%" },
        { text: "事業場住所", value: "location_address", sortable: false, width: "25%" },
      ],
      trader_locations: [],
      pagination: {
        current_page: 1,
        total_count: 0
      },
      searchForm: {
        mode: "trader",
        code: null,
        name: null,
        zip_code: null,
        prefecture_code: null,
        address: null,
        phone_number: null,
      },
      modes: [
        { value: "trader", text: "報告不要業者" },
        { value: "trader_location", text: "報告不要事業場" },
      ],
      withSelected: false,
    }
  },
  watch: {
    dialog(val) {
      Object.assign(this.$data.searchForm, this.$options.data().searchForm);
      Object.assign(this.$data.pagination, this.$options.data().pagination);
      this.trader_locations = [];
      this.withSelected = false;
      this.scrollToTop();
      this.unSelectRow();
      if (val) {
        this.searchNoneReportTraders();
      }
    },
  },
  computed: {},
  methods: {
    ...mapActions("DriverTransferNoneReportTrader", {
      fetchNoneReportTraderLocations: "index",
      updateTransferManifest: "update",
    }),
    /**
     * 検索ボタン クリックイベント
     */
    searchButtonClickEvent () {
      this.page = 1;
      this.unSelectRow();
      this.searchNoneReportTraders();
    },
    /**
     * ページ番号 チェンジイベント
     */
    pageChangeEvent() {
      this.unSelectRow();
      this.searchNoneReportTraders()
    },
    /**
     * 一覧行 クリックイベント
     * @param item
     * @param row
     */
    rowClickEvent(item, row) {
      this.selectedItem = item;
      this.selectedRow = row;
      row.select(true);
    },
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      let modalOption = {
        title: '確認',
        message: '紐付けします。よろしいですか？',
        options: {width: 320, isCancelButton: true}
      }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.registerTransformManifest();
        }
      })
    },
    /**
     * 検索処理
     */
    searchNoneReportTraders() {
      const params = {
        page: this.page,
        vendor_type: this.targetItem.vendor_type,
        ...this.searchForm
      };
      this.fetchNoneReportTraderLocations({params: params}).then((content) => {
        if (this.targetItem.vendor_type === 'transporter') {
          this.trader_locations = content.none_report_traders;
          this.pagination = content.pagination;
        } else {
          this.trader_locations = content.none_report_trader_locations;
          this.pagination = content.pagination;
        }
      });
    },
    /**
     * 登録処理
     */
    registerTransformManifest () {
      const params = {
        none_report_trader_id: this.selectedItem.none_report_trader_id,
        none_report_trader_location_code: this.selectedItem.location_code,
        target_section: this.targetItem.section,
        target_type: this.targetItem.vendor_type,
        jwnet_manifest_ids: this.withSelected ? this.targetSelectableIds : [],
        searched_at: this.searchedAt,
      }
      this.updateTransferManifest({ id: this.targetItem.jwnet_manifest_id, params: params }).then(() => {
        this.$emit("registerCallback");
      })

    },
    /**
     * 表示種別名を返す.
     * @param section {number}
     * @param type {string}
     * @returns {string}
     */
    vendorName (section, type) {
      if (type === "disposer") {
        return "処分業者";
      } else {
        return `区間${section}${type === 'transporter' ? '収運業者' : '運搬先'}`
      }
    },
    unSelectRow () {
      if (this.selectedRow) {
        this.selectedRow.select(false)
      }
      this.selectedItem = null
      this.selectedRow = null
    },
    scrollToTop () {
      const elements = document.getElementsByClassName('noneReportTraderSearchBody');
      if (!elements || !elements.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      elements[0].scrollTop = 0;
    },
  },

}
</script>

<template>
  <div>
    <v-dialog
      :value="dialog"
      width="1400"
      scrollable
      @click:outside="closeButtonClickEvent"
      @close="closeButtonClickEvent"
      @keydown.esc="closeButtonClickEvent"
    >
      <v-card>
        <v-toolbar
          color="primary"
          dark
          flat
        >
          <v-toolbar-title>
            報告不要業者紐付け
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              icon
              dark
              @click="closeButtonClickEvent"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-subtitle>
          <fieldset class="transfer-header pa-2 mt-2">
            <legend>JWNET報告不要業者情報</legend>
            <v-row dense>
              <v-col cols="12" md="2">
                <h6>{{targetItem.manifest_no}}</h6>
                <span>{{vendorName(targetItem.section, targetItem.vendor_type)}}</span>
              </v-col>
              <v-col cols="12" md="3">
                <h6>{{ targetItem.jwnet_name }}</h6>
                <span>{{ targetItem.jwnet_address }}</span>
              </v-col>
              <v-col cols="12" md="3">
                <h6>{{ targetItem.jwnet_location_name }}</h6>
                <span>{{ targetItem.jwnet_location_address }}</span>
              </v-col>
            </v-row>
          </fieldset>
        </v-card-subtitle>
        <v-card-text
          class="noneReportTraderSearchBody"
          style="height: 45vh"
        >
          <v-row>
            <v-col>
              <v-expansion-panels
                v-model="panel"
                accordion
              >
                <v-expansion-panel>
                  <v-expansion-panel-header
                    class="panel-header-color panel-selectable"
                  >
                    <strong>
                      <v-icon class="panel-header-color"> mdi-magnify </v-icon>
                      &nbsp;条件を指定して検索
                    </strong>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card flat>
                      <v-card-text>
                        <v-row dense>
                          <!-- 事業者コード -->
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="searchForm.code"
                              :label="searchForm.mode === 'trader' ? '事業者コード' : '事業場コード'"
                              clearable
                              dense
                              hide-details="auto"
                              outlined
                              persistent-placeholder
                              placeholder="例）K001"
                              rounded
                              style="font-size: 80%"
                              @blur="searchButtonClickEvent"
                              @click:clear="() => { searchForm.code = null; searchButtonClickEvent(); }"
                            />
                          </v-col>
                          <!-- /事業者コード -->
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="searchForm.name"
                              clearable
                              dense
                              hide-details="auto"
                              label="名称"
                              outlined
                              persistent-hint
                              persistent-placeholder
                              rounded
                              style="font-size: 80%"
                              @blur="searchButtonClickEvent"
                              @click:clear="() => { searchForm.name = null; searchButtonClickEvent(); }"
                            />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="searchForm.zip_code"
                              clearable
                              dense
                              hide-details="auto"
                              label="郵便番号"
                              outlined
                              persistent-hint
                              persistent-placeholder
                              rounded
                              style="font-size: 80%"
                              @blur="searchNoneReportTraders"
                              @click:clear="() => { searchForm.zip_code = null; searchButtonClickEvent(); }"
                            />
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-autocomplete
                              v-model="searchForm.prefecture_code"
                              :items="prefList"
                              clearable
                              dense
                              hide-details="auto"
                              label="都道府県"
                              outlined
                              persistent-placeholder
                              placeholder="例）東京都"
                              rounded
                              style="font-size: 80%"
                              @change="searchButtonClickEvent"
                              @click:clear="() => { searchForm.prefecture_code = null; searchButtonClickEvent(); }"
                            />
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="searchForm.address"
                              clearable
                              dense
                              label="市区町村・町域・詳細住所"
                              hide-details="auto"
                              outlined
                              persistent-placeholder
                              placeholder="例）中央区日本橋兜町１－２－３○○ビル○階"
                              rounded
                              style="font-size: 80%"
                              @blur="searchButtonClickEvent"
                              @click:clear="() => { searchForm.address = null; searchButtonClickEvent(); }"
                            />
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="searchForm.phone_number"
                              autocomplete="off"
                              clearable
                              dense
                              hint="電話番号を「-」ハイフン「( )」込みで入力します"
                              hide-details="auto"
                              label="電話番号"
                              outlined
                              persistent-placeholder
                              placeholder="例）000-0000-0000"
                              persistent-hint
                              rounded
                              style="font-size: 80%"
                              @blur="searchButtonClickEvent"
                              @click:clear="() => { searchForm.phone_number = null; searchButtonClickEvent(); }"
                            />
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-divider />
                      <v-card-actions>
                        <v-spacer />
                        <v-btn color="primary" @click="searchButtonClickEvent">検索</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-data-table
                :headers="tableHeaders"
                :items="trader_locations"
                :items-per-page="-1"
                disable-sort
                hide-default-footer
                single-select
                @click:row="rowClickEvent"
              >
                <template v-slot:[`item.trader_code`]="{ item }">
                  <div>{{ item.code }}</div>
                </template>
                <template v-slot:[`item.trader_name`]="{ item }">
                  <div
                    class="text-ellipsis text-sm-caption"
                    :title="item.trader_name"
                    style="width: 150px;"
                  >{{ item.trader_name }}</div>
                </template>
                <template v-slot:[`item.trader_address`]="{ item }">
                  <div><small>〒&nbsp;{{ item.trader_zip_code }}</small></div>
                  <div
                    class="text-ellipsis text-sm-caption"
                    :title="item.trader_address"
                    style="width: 250px;"
                  >{{ item.trader_address }}</div>
                </template>
                <template v-slot:[`item.location_name`]="{ item }">
                  <div
                    class="text-ellipsis text-sm-caption"
                    :title="item.location_name"
                    style="width: 150px;"
                  >{{ item.location_name }}</div>
                </template>
                <template v-slot:[`item.location_address`]="{ item }">
                  <div v-if="item.location_zip_code != null"><small>〒&nbsp;{{ item.location_zip_code }}</small></div>
                  <div
                    class="text-ellipsis text-sm-caption"
                    :title="item.location_address"
                    style="width: 250px;"
                  >{{ item.location_address }}</div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <!-- ページャ -->
          <v-row class="mb-15">
            <v-col>
              <v-pagination
                v-model="page"
                :length="pagination.total_pages"
                :total-visible="totalVisible"
                circle
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
                @input="pageChangeEvent"
              />
            </v-col>
          </v-row>
          <!-- /ページャ -->
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-checkbox
            v-model="withSelected"
            :label="targetItem.vendor_type === 'transporter' ? '同じ業者名のマニフェスト（紐付け未設定）にも紐付けする': '同じ業者名＋事業場名のマニフェスト（紐付け未設定）にも紐付けする'"
            class="mr-5"
            dense
            persistent-hint
            persistent-placeholder
            style="font-size: 80%"
          />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            :disabled="selectedItem === null"
            color="primary"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>
      </v-card>
      <confirm ref="confirm" />
    </v-dialog>
  </div>
</template>
